/* eslint-disable max-len */
import React from "react"

interface AvatarFrontProps {
  className?: string
  alt?: string
}
const AvatarFront: React.FC<AvatarFrontProps> = ({ className, alt = "" }) => (
  <svg
    xmlns="http://www.w3.org/var(--gil-colors-fg)/svg"
    width={680}
    height={490}
    fill="none"
    viewBox="0 0 680 490"
    className={className}
  >
    <defs>
      <title>{alt}</title>
      <clipPath id="a">
        <rect width={420} height={48} x={133} y={384} fill="#fff" rx={14} />
      </clipPath>
      <clipPath id="c">
        <rect width={22} height={22} x={502} y={397} fill="#fff" rx={4} />
      </clipPath>
      <clipPath id="d">
        <path fill="#fff" d="M501 396h24v24h-24z" />
      </clipPath>
      {/* <clipPath id="f">
        <path fill="#fff" d="M549 227h20v20h-20z" />
      </clipPath>
      <clipPath id="g">
        <path fill="#fff" d="M549 227h20v20h-20z" />
      </clipPath>
      <clipPath id="h">
        <path fill="#fff" d="M573 227h20v20h-20z" />
      </clipPath>
      <clipPath id="i">
        <path fill="#fff" d="M573 227h20v20h-20z" />
      </clipPath>
      <clipPath id="j">
        <path fill="#fff" d="M597 227h20v20h-20z" />
      </clipPath>
      <clipPath id="k">
        <path fill="#fff" d="M597 227h20v20h-20z" />
      </clipPath>
      <clipPath id="l">
        <path fill="#fff" d="M621 227h20v20h-20z" />
      </clipPath>
      <clipPath id="m">
        <path fill="#fff" d="M621 227h20v20h-20z" />
      </clipPath>
      <clipPath id="n">
        <path fill="#fff" d="M645 227h20v20h-20z" />
      </clipPath>
      <clipPath id="o">
        <path fill="#fff" d="M645 227h20v20h-20z" />
      </clipPath> */}
      <clipPath id="p">
        <rect width={58} height={32} x={547} y={135} fill="#fff" rx={16} />
      </clipPath>
      <filter
        id="q"
        width={32.363}
        height={32.666}
        x={573}
        y={135.667}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy={1} />
        <feGaussianBlur stdDeviation={1} />
        <feColorMatrix values="0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.06 0" />
        <feBlend
          in2="BackgroundImageFix"
          result="effect1_dropShadow_615_17907"
        />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy={1} />
        <feGaussianBlur stdDeviation={1.5} />
        <feColorMatrix values="0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.1 0" />
        <feBlend
          in2="effect1_dropShadow_615_17907"
          result="effect2_dropShadow_615_17907"
        />
        <feBlend
          in="SourceGraphic"
          in2="effect2_dropShadow_615_17907"
          result="shape"
        />
      </filter>
      <filter
        id="r"
        width={40}
        height={40}
        x={157}
        y={334}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy={1} />
        <feGaussianBlur stdDeviation={1.5} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0" />
        <feBlend
          in2="BackgroundImageFix"
          result="effect1_dropShadow_615_17907"
        />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy={5} />
        <feGaussianBlur stdDeviation={6} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.13 0" />
        <feBlend
          in2="effect1_dropShadow_615_17907"
          result="effect2_dropShadow_615_17907"
        />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset />
        <feGaussianBlur stdDeviation={0.25} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
        <feBlend
          in2="effect2_dropShadow_615_17907"
          result="effect3_dropShadow_615_17907"
        />
        <feBlend
          in="SourceGraphic"
          in2="effect3_dropShadow_615_17907"
          result="shape"
        />
      </filter>
      <filter
        id="s"
        width={32}
        height={32}
        x={161}
        y={338}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy={1} />
        <feGaussianBlur stdDeviation={1.5} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0" />
        <feBlend
          in2="BackgroundImageFix"
          result="effect1_dropShadow_615_17907"
        />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy={5} />
        <feGaussianBlur stdDeviation={6} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.13 0" />
        <feBlend
          in2="effect1_dropShadow_615_17907"
          result="effect2_dropShadow_615_17907"
        />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset />
        <feGaussianBlur stdDeviation={0.25} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
        <feBlend
          in2="effect2_dropShadow_615_17907"
          result="effect3_dropShadow_615_17907"
        />
        <feBlend
          in="SourceGraphic"
          in2="effect3_dropShadow_615_17907"
          result="shape"
        />
      </filter>
      <filter
        id="t"
        width={20}
        height={20}
        x={464.5}
        y={280.5}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy={1} />
        <feGaussianBlur stdDeviation={1.5} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.35 0" />
        <feBlend
          in2="BackgroundImageFix"
          result="effect1_dropShadow_615_17907"
        />
        <feBlend
          in="SourceGraphic"
          in2="effect1_dropShadow_615_17907"
          result="shape"
        />
      </filter>
      <linearGradient
        id="e"
        x1={607}
        x2={607}
        y1={211}
        y2={263}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#fff" />
        <stop offset={1} stopColor="#f9f9f9" stopOpacity={0.56} />
      </linearGradient>
    </defs>
    <g clipPath="url(#a)">
      <rect
        width={420}
        height={48}
        x={133}
        y={384}
        fill="var(--bgCardColor)"
        stroke="var(--gil-colors-border-emphasized)"
        strokeWidth={1}
        rx={14}
      />
      <rect
        width={49}
        height={32}
        x={141}
        y={392}
        fill="var(--bgCardColor)"
        rx={5}
      />
      <path
        fill="#0d99ff"
        d="M141 397a5 5 0 0 1 5-5h22a5 5 0 0 1 5 5v22a5 5 0 0 1-5 5h-22a5 5 0 0 1-5-5z"
      />
      <path
        fill="var(--gil-colors-white)"
        d="M149.586 400.586a2 2 0 0 1 2.145-.447l13 5.107a2 2 0 0 1-.143 3.773l-5.025 1.544-1.544 5.025a2 2 0 0 1-3.773.143l-5.107-13a2 2 0 0 1 .447-2.145m1.779.483a1 1 0 0 0-1.072.224l-.097.111a1 1 0 0 0-.127.961l5.108 13c.136.347.45.585.811.628l.158.006a1 1 0 0 0 .916-.705l1.703-5.529 5.529-1.703a1 1 0 0 0 .687-.76l.018-.156a1 1 0 0 0-.492-.901l-.142-.068z"
      />
      <path
        fill="var(--gil-colors-fg)"
        fillOpacity={0.9}
        d="M183.768 406.768a.5.5 0 1 1 .708.707L182 409.949l-2.475-2.474a.5.5 0 0 1 .707-.707l1.768 1.767z"
      />
      <rect
        width={32}
        height={32}
        x={198}
        y={392}
        fill="var(--bgCardColor)"
        rx={5}
      />
      <path
        fill="var(--gil-colors-fg)"
        fillOpacity={0.9}
        d="M218.5 400a.5.5 0 0 1 .5.5v2.5h2.5a.5.5 0 0 1 0 1H219v8h2.5a.5.5 0 0 1 0 1H219v2.5a.5.5 0 0 1-1 0V413h-8v2.5a.5.5 0 0 1-1 0V413h-2.5a.5.5 0 0 1 0-1h2.5v-8h-2.5a.5.5 0 0 1 0-1h2.5v-2.5a.5.5 0 0 1 1 0v2.5h8v-2.5a.5.5 0 0 1 .5-.5m-8.5 4v8h8v-8z"
      />
      <rect
        width={16}
        height={24}
        x={231}
        y={396}
        fill="var(--bgCardColor)"
        rx={5}
      />
      <path
        fill="var(--gil-colors-fg)"
        fillOpacity={0.9}
        d="M240.768 406.768a.5.5 0 1 1 .708.707L239 409.949l-2.475-2.474a.5.5 0 0 1 .707-.707l1.768 1.767z"
      />
      <rect
        width={32}
        height={32}
        x={255}
        y={392}
        fill="var(--bgCardColor)"
        rx={5}
      />
      <path
        fill="var(--gil-colors-fg)"
        fillOpacity={0.9}
        d="M275.5 402a1.5 1.5 0 0 1 1.5 1.5v9a1.5 1.5 0 0 1-1.5 1.5h-9a1.5 1.5 0 0 1-1.5-1.5v-9a1.5 1.5 0 0 1 1.5-1.5zm-9 1a.5.5 0 0 0-.5.5v9a.5.5 0 0 0 .5.5h9a.5.5 0 0 0 .5-.5v-9a.5.5 0 0 0-.5-.5z"
      />
      <rect
        width={16}
        height={24}
        x={288}
        y={396}
        fill="var(--bgCardColor)"
        rx={5}
      />
      <path
        fill="var(--gil-colors-fg)"
        fillOpacity={0.9}
        d="M297.768 406.768a.5.5 0 1 1 .708.707L296 409.949l-2.475-2.474a.5.5 0 0 1 .707-.707l1.768 1.767z"
      />
      <rect
        width={32}
        height={32}
        x={312}
        y={392}
        fill="var(--bgCardColor)"
        rx={5}
      />
      <path
        fill="var(--gil-colors-fg)"
        fillOpacity={0.9}
        d="M320.335 401.967a1.39 1.39 0 0 1 1.635-1.635c3.189.594 9.348 1.983 11.532 4.167 1.966 1.967 2.428 4.149 1.809 6.124l1.398 1.397a1 1 0 0 1 0 1.414l-3.272 3.272a1 1 0 0 1-1.414 0l-1.398-1.398c-1.974.62-4.156.159-6.123-1.808-2.184-2.184-3.573-8.344-4.167-11.533m6.651 4.311a2 2 0 1 1-.707.707l-4.904-4.904c.298 1.56.765 3.705 1.401 5.73.652 2.075 1.428 3.846 2.265 4.802l.168.18c1.733 1.733 3.536 2.057 5.116 1.561l.578-.181 1.827 1.826 3.271-3.272-1.825-1.825.181-.579c.464-1.482.208-3.16-1.254-4.792l-.308-.325c-.902-.901-2.769-1.737-4.982-2.432-2.026-.636-4.173-1.104-5.733-1.402zm.308 1.014a1 1 0 1 0 1.416 1.414 1 1 0 0 0-1.416-1.414"
      />
      <rect
        width={16}
        height={24}
        x={345}
        y={396}
        fill="var(--bgCardColor)"
        rx={5}
      />
      <path
        fill="var(--gil-colors-fg)"
        fillOpacity={0.9}
        d="M354.768 406.768a.5.5 0 1 1 .708.707L353 409.949l-2.475-2.474a.5.5 0 0 1 .707-.707l1.768 1.767z"
      />
      <path
        fill="var(--bgCardColor)"
        d="M369 397a5 5 0 0 1 5-5h22a5 5 0 0 1 5 5v22a5 5 0 0 1-5 5h-22a5 5 0 0 1-5-5z"
      />
      <path
        fill="var(--gil-colors-fg)"
        fillOpacity={0.9}
        d="M392.5 400a.5.5 0 0 1 .5.5v3a.5.5 0 0 1-1 0V401h-6.5v14h2.5a.5.5 0 0 1 0 1h-6a.5.5 0 0 1 0-1h2.5v-14H378v2.5a.5.5 0 0 1-1 0v-3a.5.5 0 0 1 .5-.5z"
      />
      <path
        fill="var(--bgCardColor)"
        d="M409 397a5 5 0 0 1 5-5h22a5 5 0 0 1 5 5v22a5 5 0 0 1-5 5h-22a5 5 0 0 1-5-5z"
      />
      <path
        fill="var(--gil-colors-fg)"
        fillOpacity={0.9}
        d="M425 400a8 8 0 0 1 0 16h-4.8l-.742-.003c-.542-.008-.906-.039-1.198-.143l-.168-.072a2 2 0 0 1-.797-.736l-.077-.138c-.218-.428-.218-.988-.218-2.108V408a8 8 0 0 1 8-8m0 1a7 7 0 0 0-7 7v4.8c0 .576.001.949.024 1.232.023.272.06.373.085.422.096.188.249.341.437.437.049.025.15.062.422.085.283.023.656.024 1.232.024h4.8a7 7 0 1 0 0-14"
      />
      <circle cx={430.5} cy={402.5} r={2.5} fill="#f24822" />
      <path
        fill="var(--bgCardColor)"
        d="M449 397a5 5 0 0 1 5-5h22a5 5 0 0 1 5 5v22a5 5 0 0 1-5 5h-22a5 5 0 0 1-5-5z"
      />
      <path
        fill="var(--gil-colors-fg)"
        fillOpacity={0.9}
        d="M470.501 412a.5.5 0 0 1 .5.5v1.5h1.5a.5.5 0 0 1 0 1h-1.5v1.5a.5.5 0 0 1-1 0V415h-1.5a.5.5 0 0 1 0-1h1.5v-1.5a.5.5 0 0 1 .5-.5m-8.619-10.895c.565-1.495 2.717-1.495 3.282 0l.051.156 1.116 3.907 3.909 1.117c1.702.487 1.702 2.899 0 3.385l-3.909 1.116-1.116 3.908c-.486 1.702-2.898 1.702-3.384 0l-1.116-3.905-3.916-1.103c-1.705-.481-1.713-2.895-.011-3.385l3.926-1.132 1.117-3.908zm2.372.43c-.21-.734-1.252-.735-1.462 0l-1.269 4.443-4.458 1.284c-.735.211-.732 1.254.004 1.462l4.454 1.254 1.269 4.442c.197.689 1.125.732 1.413.129l.049-.129 1.269-4.442 4.443-1.27c.688-.197.731-1.124.129-1.412l-.129-.049-4.443-1.269zm6.247-2.535a2.5 2.5 0 1 1 0 5 2.5 2.5 0 0 1 0-5m0 1a1.5 1.5 0 1 0 .001 3.001 1.5 1.5 0 0 0-.001-3.001"
      />
      <path
        fill="var(--bgCardColor)"
        d="M489 384h50c7.732 0 14 6.268 14 14v20c0 7.732-6.268 14-14 14h-50z"
      />
      <path
        fill="var(--bgColor)"
        d="M489 384h64zm64 48h-64zm-65 0v-48h2v48zm65-48v48z"
        mask="url(#b)"
      />
      <rect
        width={40}
        height={24}
        x={501}
        y={396}
        fill="var(--bgColor)"
        rx={5}
      />
      <g clipPath="url(#c)">
        <rect
          width={22}
          height={22}
          x={502}
          y={397}
          fill="var(--bgCardColor)"
          rx={4}
        />
        <g clipPath="url(#d)">
          <path
            fill="var(--gil-colors-fg)"
            fillOpacity={0.9}
            d="M510.646 404.146a.502.502 0 0 1 .708.708L508.207 408l3.147 3.146a.502.502 0 0 1-.708.708l-3.5-3.5a.5.5 0 0 1 0-.708zm4 0a.5.5 0 0 1 .708 0l3.5 3.5a.5.5 0 0 1 0 .708l-3.5 3.5a.502.502 0 0 1-.708-.708l3.147-3.146-3.147-3.146a.5.5 0 0 1 0-.708"
          />
        </g>
      </g>
    </g>
    <path
      fill="#007be5"
      d="M486 298h96c7.732 0 14 6.268 14 14s-6.268 14-14 14h-79.805c-9.496 0-17.195-7.699-17.195-17.195V299a1 1 0 0 1 1-1"
    />
    <path
      stroke="#0768cf"
      strokeWidth={2}
      d="M486 298h96c7.732 0 14 6.268 14 14s-6.268 14-14 14h-79.805c-9.496 0-17.195-7.699-17.195-17.195V299a1 1 0 0 1 1-1Z"
    />
    <rect
      width={52}
      height={14}
      x={496}
      y={305}
      fill="var(--gil-colors-white)"
      rx={7}
    />
    <rect
      width={27}
      height={14}
      x={554}
      y={305}
      fill="var(--gil-colors-white)"
      rx={7}
    />
    <g>
      <rect
        width={143.5}
        height={49.5}
        x={535.25}
        y={212.25}
        fill="var(--bgCardColor)"
        stroke="var(--gil-colors-border-emphasized)"
        strokeOpacity={1}
        strokeWidth={1}
        rx={12.75}
      />
      {/* <rect
      width={143.5}
      height={49.5}
      x={535.25}
      y={212.25}
      stroke="url(#d)"
      strokeWidth={2.5}
      rx={12.75}
    /> */}

      <path
        fill="var(--gil-colors-orange-400)"
        stroke="var(--gil-colors-orange-600)"
        strokeOpacity={1}
        strokeWidth={1}
        d="M558.538 228.61a.5.5 0 0 1 .924 0l2.066 4.967a.5.5 0 0 0 .421.307l5.363.43a.5.5 0 0 1 .286.878l-4.086 3.5a.5.5 0 0 0-.161.496l1.248 5.233a.5.5 0 0 1-.747.543l-4.591-2.805a.5.5 0 0 0-.522 0l-4.591 2.805a.5.5 0 0 1-.747-.543l1.248-5.233a.5.5 0 0 0-.161-.496l-4.086-3.5a.5.5 0 0 1 .286-.878l5.363-.43a.5.5 0 0 0 .421-.307z"
      />

      <path
        fill="var(--gil-colors-orange-400)"
        stroke="var(--gil-colors-orange-600)"
        strokeOpacity={1}
        strokeWidth={1}
        d="M582.538 228.61a.5.5 0 0 1 .924 0l2.066 4.967a.5.5 0 0 0 .421.307l5.363.43a.5.5 0 0 1 .286.878l-4.086 3.5a.5.5 0 0 0-.161.496l1.248 5.233a.5.5 0 0 1-.747.543l-4.591-2.805a.5.5 0 0 0-.522 0l-4.591 2.805a.5.5 0 0 1-.747-.543l1.248-5.233a.5.5 0 0 0-.161-.496l-4.086-3.5a.5.5 0 0 1 .286-.878l5.363-.43a.5.5 0 0 0 .421-.307z"
      />

      <path
        fill="var(--gil-colors-orange-400)"
        stroke="var(--gil-colors-orange-600)"
        strokeOpacity={1}
        strokeWidth={1}
        d="M606.538 228.61a.5.5 0 0 1 .924 0l2.066 4.967a.5.5 0 0 0 .421.307l5.363.43a.5.5 0 0 1 .286.878l-4.086 3.5a.5.5 0 0 0-.161.496l1.248 5.233a.5.5 0 0 1-.747.543l-4.591-2.805a.5.5 0 0 0-.522 0l-4.591 2.805a.5.5 0 0 1-.747-.543l1.248-5.233a.5.5 0 0 0-.161-.496l-4.086-3.5a.5.5 0 0 1 .286-.878l5.363-.43a.5.5 0 0 0 .421-.307z"
      />

      <path
        fill="var(--gil-colors-orange-400)"
        stroke="var(--gil-colors-orange-600)"
        strokeOpacity={1}
        strokeWidth={1}
        d="M630.538 228.61a.5.5 0 0 1 .924 0l2.066 4.967a.5.5 0 0 0 .421.307l5.363.43a.5.5 0 0 1 .286.878l-4.086 3.5a.5.5 0 0 0-.161.496l1.248 5.233a.5.5 0 0 1-.747.543l-4.591-2.805a.5.5 0 0 0-.522 0l-4.591 2.805a.5.5 0 0 1-.747-.543l1.248-5.233a.5.5 0 0 0-.161-.496l-4.086-3.5a.5.5 0 0 1 .286-.878l5.363-.43a.5.5 0 0 0 .421-.307z"
      />

      <path
        fill="var(--gil-colors-orange-400)"
        stroke="var(--gil-colors-orange-600)"
        strokeOpacity={1}
        strokeWidth={1}
        d="M654.538 228.61a.5.5 0 0 1 .924 0l2.066 4.967a.5.5 0 0 0 .421.307l5.363.43a.5.5 0 0 1 .286.878l-4.086 3.5a.5.5 0 0 0-.161.496l1.248 5.233a.5.5 0 0 1-.747.543l-4.591-2.805a.5.5 0 0 0-.522 0l-4.591 2.805a.5.5 0 0 1-.747-.543l1.248-5.233a.5.5 0 0 0-.161-.496l-4.086-3.5a.5.5 0 0 1 .286-.878l5.363-.43a.5.5 0 0 0 .421-.307z"
      />
    </g>
    <g clipPath="url(#p)">
      <rect width={58} height={32} x={547} y={135} fill="#007be4" rx={16} />
      <g filter="url(#q)">
        <ellipse
          cx={589.182}
          cy={151}
          fill="var(--bgCardColorDarker)"
          rx={13.182}
          ry={13.333}
        />
      </g>
    </g>
    <path
      fill="var(--bgCardColor)"
      d="M27 349a8 8 0 0 1 8-8h192a8 8 0 0 1 0 16H35a8 8 0 0 1-8-8"
    />
    <path
      stroke="var(--gil-colors-fg)"
      strokeOpacity={0.1}
      d="M35 341.5h192a7.5 7.5 0 0 1 0 15H35a7.5 7.5 0 0 1 0-15Z"
    />
    <rect width={156} height={16} x={27} y={341} fill="#0d99ff" rx={8} />
    <path
      fill="var(--bgColor)"
      d="M177 341a8 8 0 1 1 0 16 8 8 0 0 1 0-16m0 3.556a4.443 4.443 0 0 0-4.444 4.444 4.443 4.443 0 0 0 4.444 4.444 4.443 4.443 0 0 0 4.444-4.444 4.443 4.443 0 0 0-4.444-4.444"
    />
    <path
      fill="var(--bgCardColorDarker)"
      d="M177 342a7 7 0 1 1 0 14 7 7 0 0 1 0-14m0 3a4 4 0 1 0 0 8 4 4 0 0 0 0-8"
    />
    <g filter="url(#s)">
      <circle
        cx={177}
        cy={349}
        r={3.75}
        stroke="var(--gil-colors-fg)"
        strokeOpacity={0.1}
        strokeWidth={0.5}
      />
    </g>
    <g filter="url(#t)">
      <path
        fill="#fff"
        fillRule="evenodd"
        d="M467.939 282.939a1.5 1.5 0 0 1 1.588-.343l11 4.125a1.5 1.5 0 0 1-.163 2.859l-4.627 1.157-1.157 4.627a1.5 1.5 0 0 1-2.859.163l-4.125-11a1.5 1.5 0 0 1 .343-1.588"
        clipRule="evenodd"
      />
    </g>
    <path
      fill="#007be5"
      fillRule="evenodd"
      d="M469.176 283.532a.5.5 0 0 0-.53.114.5.5 0 0 0-.114.53l4.125 11a.498.498 0 0 0 .953-.055l1.302-5.209 5.209-1.302a.499.499 0 0 0 .055-.953z"
      clipRule="evenodd"
    />
  </svg>
)

export default AvatarFront
